import type { FC } from 'react';

import type { AboutUsSubpageFactsFragmentFragment } from '../../graphql/fragment/about-us-subpage-facts-fragment.gql-types';

import { FactsCompany } from './facts-company';
import { FactsPublisher } from './facts-publisher';

type FactsContainerProps = {
  facts: AboutUsSubpageFactsFragmentFragment;
};

export const FactsContainer: FC<FactsContainerProps> = ({ facts }) => {
  if (facts.__typename === 'CompanyAboutUsFacts') {
    return <FactsCompany facts={facts} />;
  }
  if (facts.__typename === 'PublisherAboutUsFacts') {
    return <FactsPublisher facts={facts} />;
  }
  return null;
};
